import { render, staticRenderFns } from "./SurveysubjectListAddNew.vue?vue&type=template&id=0cbedd59&"
import script from "./SurveysubjectListAddNew.vue?vue&type=script&lang=js&"
export * from "./SurveysubjectListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./SurveysubjectListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports